module.exports = __webpack_public_path__ + "static/cvt-logo-full-text-c1783a63a2e1b0ada8a40255716f5a48.png";